module.exports = __webpack_public_path__ + "static/freescantrio26lines-941c9ec60d63ca2a6351ba982fb142dc.jpg";